import { queryClient } from '@/lib/query-client';
import {
  DEFAULT_TERM_LABELS,
  translateHierarchyTerms,
  type HierarchyTerm,
  type HierarchyTermLabels,
} from './hierarchy-terms';

export const HIERARCHY_LABELS_QUERY_KEY = ['tenant-config', 'hierarchy-labels'] as const;

type StoredLabels = Partial<Record<`${HierarchyTerm}Label` | `${HierarchyTerm}LabelPlural`, string | null>>;

const TERMS = Object.keys(DEFAULT_TERM_LABELS) as HierarchyTerm[];

function chosen(value: string | null | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed === '' ? undefined : trimmed;
}

export function termLabelsFrom(stored: StoredLabels | undefined): HierarchyTermLabels {
  const entries = TERMS.map((term) => {
    const singular = chosen(stored?.[`${term}Label`]) ?? DEFAULT_TERM_LABELS[term].singular;
    const plural = chosen(stored?.[`${term}LabelPlural`]) ?? `${singular}s`;
    return [term, { singular, plural }] as const;
  });
  return Object.fromEntries(entries) as HierarchyTermLabels;
}

export function translateWithCurrentLabels(text: string): string {
  const stored = queryClient.getQueryData<StoredLabels>(HIERARCHY_LABELS_QUERY_KEY);
  return stored ? translateHierarchyTerms(text, termLabelsFrom(stored)) : text;
}
